/* Freya Gurme — tarif kataloğu (tek kaynak).
   Tarifler freyagurme.com/blogs içeriğinden alınmıştır. Tam malzeme &
   adım içeren 5 tarif + diğerleri için kategori/başlık. `productSlug`
   ilgili ürüne bağlar (görsel + renk için products.js kullanılır).
   Foto-swap: images/recipes/{slug}.jpg varsa otomatik bindirilir. */

window.FREYA_RECIPE_CATS = {
  ana: { label: "Ana Yemek" },
  salata: { label: "Salata & Aperatif" },
  tatli: { label: "Tatlı" },
  kahvalti: { label: "Kahvaltı & Granola" },
  kokteyl: { label: "Kokteyl" },
};

window.FREYA_RECIPES = [
  {
    slug: "carkifelek-somon-ceviche",
    cat: "ana",
    title: "Çarkıfelek Somon Ceviche",
    productSlug: "carkifelek-sosu",
    product: "Çarkıfelek Sosu",
    serves: "2 kişilik",
    time: "15 dk",
    summary: "Çarkıfelek sosunun tropikal tatlı-ekşisiyle taze somonun buluştuğu, 15 dakikalık zarif bir başlangıç.",
    ingredients: [
      "250 g somon fileto",
      "1 kırmızı soğan (ince doğranmış)",
      "1 yeşil biber (ince doğranmış)",
      "150 g Freya Gurme Çarkıfelek Sosu",
      "15 ml soya sosu",
      "10 ml limon suyu",
      "10 g kişniş",
      "2 g tuz",
    ],
    steps: [
      "Somonu küp küp doğrayın.",
      "Soya sosu, soğan, biber ve kişnişi ekleyip iyice karıştırın.",
      "Çarkıfelek sosu, limon suyu ve tuzu ekleyin.",
      "Tabağa alıp servis edin. Afiyet olsun!",
    ],
  },
  {
    slug: "carkifelek-soslu-karides-kanepe",
    cat: "salata",
    title: "Çarkıfelek Soslu Karides Kanepe",
    productSlug: "carkifelek-sosu",
    product: "Çarkıfelek Sosu",
    serves: "9 adet",
    time: "15 dk + 4 dk pişirme",
    summary: "Labne kreması, ızgara jumbo karides ve çarkıfelek sosuyla davetlere yakışan şık kanepeler.",
    ingredients: [
      "9 dilim Alman ekmeği (ikiye bölünmüş)",
      "150 g süzme yoğurt",
      "80 g labne",
      "¼ demet dereotu (ince kıyılmış)",
      "½ limon (kabuğu rendelenmiş + suyu)",
      "Tuz ve taze çekilmiş karabiber",
      "90 g Freya Gurme Çarkıfelek Sosu",
      "9 adet jumbo karides",
      "3 bebek turp + mikro yeşillik (süsleme)",
    ],
    steps: [
      "Karidesleri temizleyip tuz ve karabiberle hafifçe baharatlayın.",
      "Tavada zeytinyağıyla her iki yüzünü 1-2 dakika, hafif altın renk alana dek pişirip soğumaya bırakın.",
      "Süzme yoğurt, labne, dereotu, limon kabuğu ve suyunu karıştırıp tadına bakın.",
      "Ekmek dilimlerini çıtır çıtır kızartın.",
      "Yoğurt kremasını ve çarkıfelek sosunu sürün, turp dilimleri ve birer karidesle tamamlayın.",
      "Mikro yeşilliklerle süsleyip servis edin.",
    ],
  },
  {
    slug: "cilek-jalepeno-soslu-quesadillas",
    cat: "ana",
    title: "Çilek & Jalepeno Soslu Quesadillas",
    productSlug: "cilek-jalapeno-sosu",
    product: "Çilek & Jalepeno Sosu",
    serves: "2-4 kişilik",
    time: "5 dk + 8 dk pişirme",
    summary: "Çilek-jalapeñonun tatlı-acı dengesi, tavuk ve mozzarella ile eriyen pratik bir quesadilla.",
    ingredients: [
      "2 lavaş",
      "200 g haşlanıp didiklenmiş tavuk göğsü",
      "60 g rendelenmiş mozzarella",
      "90 g Freya Gurme Çilek & Jalepeno Sosu",
      "1 lime",
      "Servis için süzme yoğurt",
    ],
    steps: [
      "Tavayı orta ateşte ısıtın, bir lavaşı yerleştirin.",
      "Üzerine çilek-jalapeño sosunu sürün; didiklenmiş tavuk ve mozzarellayı ekleyip ikinci lavaşla kapatın.",
      "3-4 dakika pişirin; spatula veya kapak yardımıyla çevirin.",
      "Diğer tarafını da 3-4 dakika pişirin.",
      "Dilimleyip süzme yoğurt ve lime kabuğu rendesiyle servis edin.",
    ],
  },
  {
    slug: "maviyemis-lavanta-soslu-saglikli-dondurma",
    cat: "tatli",
    title: "Maviyemiş & Lavanta Soslu Sağlıklı Dondurma",
    productSlug: "maviyemis-lavanta-sosu",
    product: "Maviyemiş & Lavanta Sosu",
    serves: "2-4 kişilik",
    time: "5 dk + min. 5 saat dinlenme",
    summary: "Dondurulmuş muz ve maviyemiş-lavanta sosuyla, hazırlanan kremamsı 'nice cream'.",
    ingredients: [
      "80 g Freya Gurme Maviyemiş & Lavanta Sosu",
      "2 dilim dondurulmuş muz (bir gece donmuş)",
      "10 g bal",
      "Birkaç damla vanilya özütü (opsiyonel)",
      "Süsleme: ekstra sos, taze maviyemiş, kuru lavanta",
    ],
    steps: [
      "Dondurulmuş muz dilimlerini dondurma kıvamına gelene dek blenderdan geçirin.",
      "Bal, maviyemiş-lavanta sosu ve vanilyayı ekleyip pürüzsüz olana dek karıştırın.",
      "3 saat buzdolabında dinlendirin.",
      "Ekstra sos, taze maviyemiş ve kuru lavantayla servis edin.",
    ],
  },
  {
    slug: "visne-iskin-soslu-cin-tonik",
    cat: "kokteyl",
    title: "Vişne & Işkın Soslu Cin Tonik",
    productSlug: "visne-iskin-otu-sosu",
    product: "Vişne & Işkın Otu Sosu",
    serves: "1 içecek",
    time: "5 dk",
    summary: "Vişne-ışkın sosunun mayhoş derinliğiyle ferahlatıcı, 5 dakikalık imzalık bir cin tonik.",
    ingredients: [
      "5 cl cin",
      "15 g Freya Gurme Vişne & Işkın Otu Sosu",
      "1 dilim lime",
      "120 ml tonik",
      "Buz",
    ],
    steps: [
      "Tüm malzemeleri sırasıyla shaker'a koyup karıştırın.",
      "Buzlu bardağa süzün. (Tonik yerine soda da kullanabilirsiniz.)",
    ],
  },

  /* — Tam adımı sitede ayrıca yer alan, başlık+kategori ile listelenen tarifler — */
  { slug: "carkifelek-soslu-somon", cat: "ana", title: "Çarkıfelek Soslu Somon", productSlug: "carkifelek-sosu", product: "Çarkıfelek Sosu", summary: "Fırında somon fileto üzerine çarkıfelek sosunun tropikal dokunuşu." },
  { slug: "carkifelekli-karidesli-pad-thai", cat: "ana", title: "Çarkıfelekli Karidesli Pad Thai", productSlug: "carkifelek-sosu", product: "Çarkıfelek Sosu", summary: "Uzak Doğu klasiğine çarkıfelek sosuyla tatlı-ekşi bir yorum." },
  { slug: "cilek-jalepeno-bruksel-salata", cat: "salata", title: "Çilek Jalepeno & Brüksel Salata", productSlug: "cilek-jalapeno-sosu", product: "Çilek & Jalepeno Sosu", summary: "Közlenmiş Brüksel lahanası ve çilek-jalapeño sosuyla canlı bir salata." },
  { slug: "cilek-jalepeno-thumbprint-cookies", cat: "tatli", title: "Çilek Jalepeno Thumbprint Kurabiye", productSlug: "cilek-jalapeno-sosu", product: "Çilek & Jalepeno Sosu", summary: "Klasik thumbprint kurabiyelerin ortasında tatlı-acı çilek dolgusu." },
  { slug: "cilek-jalepenolu-et-sis", cat: "ana", title: "Çilek Jalepeno Et Şiş", productSlug: "cilek-jalapeno-sosu", product: "Çilek & Jalepeno Sosu", summary: "Marine et şişlere çilek-jalapeño sosuyla parlak bir glaze." },
  { slug: "maviyemis-lavanta-ve-orman-meyveli-pavlova", cat: "tatli", title: "Maviyemiş Lavanta & Orman Meyveli Pavlova", productSlug: "maviyemis-lavanta-sosu", product: "Maviyemiş & Lavanta Sosu", summary: "Çıtır beze, krema ve maviyemiş-lavanta sosuyla zarif bir pavlova." },
  { slug: "maviyemisli-vegan-kek", cat: "tatli", title: "Maviyemişli Vegan Kek", productSlug: "maviyemis-lavanta-sosu", product: "Maviyemiş & Lavanta Sosu", summary: "Yumuşacık vegan kek hamuruna maviyemiş-lavanta sosunun çiçeksi notası." },
  { slug: "zencefil-acili-armut-shot", cat: "kokteyl", title: "Zencefil & Acılı Armut Shot", productSlug: "zencefil-acili-armut-sosu", product: "Zencefil & Acılı Armut Sosu", summary: "Zencefilin keskinliğiyle ısıtan, tek yudumluk canlandırıcı bir shot." },
  { slug: "vegan-sutlu-hindistan-cevizi-granola", cat: "kahvalti", title: "Vegan Sütlü Hindistan Cevizi Granola", productSlug: "hindistan-cevizi-granola", product: "Hindistan Cevizi Granola", summary: "Bitkisel süt, taze meyve ve hindistan cevizi granolasıyla doyurucu bir kâse." },
  { slug: "carkifelek-granola", cat: "kahvalti", title: "Çarkıfelek & Granola", productSlug: "hindistan-cevizi-granola", product: "Çarkıfelek Sosu + Granola", summary: "Yoğurt, granola ve çarkıfelek sosuyla 2 dakikada hazır bir kahvaltı kâsesi." },
];
